
import React from 'react'
import { ArrowLeft } from 'react-bootstrap-icons'
import { useDispatch } from 'react-redux';
import { fetchBillingUrl } from '../../redux/actions/settingActions';
import { useSelector } from 'react-redux';

const SettingBilling = (props) => {
  const dispatch = useDispatch();
  const billingUrl = useSelector((state) => state.setting.fetchBillingUrl);

  

  let tempUrl = `${window.location.href}`;
  let setUrl;

  if (tempUrl.search("localhost") > 0) {
    setUrl = "https://www.askzoi.ai/contact"
  } else if (tempUrl.search("dev.askzoi.com") > 0) {
    setUrl = "https://www.askzoi.ai/contact"
  } else if (tempUrl.search("app.askzoi.ai") > 0) {
    setUrl = "https://www.askzoi.ai/contact"
  } else if (tempUrl.search("sia.technochimes.com") > 0) {
    setUrl = "https://www.askzoi.ai/contact"
  } else {
    setUrl = "https://www.askzoi.ai/contact"
  }

  const uData = JSON.parse(localStorage.getItem("userData"));

  const userEmail = uData?.data?.email
  const fName = uData?.data?.first_name
  const lName = uData?.data?.last_name

  return (
    <div className='flex justify-center items-center h-full relative'>
        <div className='flex flex-col justify-center items-center h-full mt-[20%] '>
        <div className='font-bold my-auto'>
        You are currently on a trial account. Please click the button below to upgrade your plan.
        </div>
        {/* <button
            onClick={()=>{handleBilling()}}
            type="button"
            className="w-[25%] mt-4 items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
           >
            Manage Billing
        </button>  */}
        <a
          href={setUrl}
          target='blank'
          className="w-[25%] text-center mt-4 items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
          >
          {/* <ArrowLeft className="-ml-0.5 h-5 w-5" aria-hidden="true" /> */}
          Contact Us
        </a>
        </div>
    </div>
  )
}

export default SettingBilling